import React from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { FaUser, FaLock, FaCalendarAlt, FaThLarge, FaInfoCircle } from 'react-icons/fa';
import { useAuth } from '../../contexts/AuthContext';
import { tryNavigateFromProfileWizard } from '../../utils/incompleteProfileLeaveGuard';

const BRAND = { blue: '#043663', red: '#D52B1E', gray: '#E5E7EB', lightGray: '#f3f4f6' };

const Wrapper = styled.div`
  width: 100%;
  max-width: none;
`;

const PageTitle = styled.h1`
  font-size: 1.5rem;
  font-weight: 600;
  color: #111827;
  margin: 0 0 1.5rem 0;
  letter-spacing: -0.02em;
`;

const Subnav = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  margin-bottom: 1.75rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid ${BRAND.gray};
`;

const SubnavLink = styled(NavLink)`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1rem;
  font-size: 0.9375rem;
  font-weight: 500;
  color: #6b7280;
  text-decoration: none;
  border-radius: 8px;
  transition: color 0.15s, background 0.15s;

  &:hover {
    color: ${BRAND.blue};
    background: ${BRAND.lightGray};
  }

  &.active {
    color: ${BRAND.blue};
    background: rgba(4, 54, 99, 0.08);
  }
`;

const Content = styled.div`
  min-height: 200px;
`;

export default function PlayerSettingsLayout() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const location = useLocation();

  const guardSubnav = (e, to) => {
    if (!tryNavigateFromProfileWizard(user, location.pathname, to)) {
      e.preventDefault();
    }
  };

  return (
    <Wrapper>
      <PageTitle>{t('phase2.playerSettings.pageTitle')}</PageTitle>
      <Subnav>
        <SubnavLink to="/player/settings" end onClick={(e) => guardSubnav(e, '/player/settings')}>
          <FaThLarge size={14} /> {t('phase2.playerSettings.overview')}
        </SubnavLink>
        <SubnavLink to="/player/settings/profile" onClick={(e) => guardSubnav(e, '/player/settings/profile')}>
          <FaUser size={14} /> {t('phase2.playerSettings.profile')}
        </SubnavLink>
        <SubnavLink to="/player/settings/availability" onClick={(e) => guardSubnav(e, '/player/settings/availability')}>
          <FaCalendarAlt size={14} /> {t('phase2.playerSettings.availability')}
        </SubnavLink>
        <SubnavLink to="/player/league-info" onClick={(e) => guardSubnav(e, '/player/league-info')}>
          <FaInfoCircle size={14} /> {t('phase2.playerSettings.leagueInfo')}
        </SubnavLink>
        <SubnavLink to="/player/settings/security" onClick={(e) => guardSubnav(e, '/player/settings/security')}>
          <FaLock size={14} /> {t('phase2.playerSettings.security')}
        </SubnavLink>
      </Subnav>
      <Content>
        <Outlet />
      </Content>
    </Wrapper>
  );
}
